var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-5"},[_c('h1',[_vm._v("Sorry, we can't find the page you're looking for!")])])}]

export { render, staticRenderFns }